module.exports = __webpack_public_path__ + "img/icon-context-menu.f363ef96.svg";